import React, { useState, useEffect } from "react";

// mui components
import { Stack } from "@mui/material";


// custom components
import Heading3 from "../../typography/heading-03";
import LoanParametersSummaryCard from "../loan-parameters-summary";
import LockParametersCard from "../lock-parameter";
import LockExtensionRequestFormCard from "../lock-extension-request-form-card";

// api services
import { useFieldMutation } from "../../../features/field-values/fieldValueApiSlice";

// helper functions
import { filterValue } from "../../../utils/filter-value";

// custom styles
import styles from "./index.module.scss";


const LockExtensionRequestCard = ({
	loanData,
	getFieldValuesOnLoanSummary,
	lockRequestedOn,
	lockStatus,
	goToDefaultView
}) => {
	const [field] = useFieldMutation();

	const [fieldValues, setFieldValues] = useState([]);
	const [obEntityID, setOBEntityID] = useState("");
	const [obUserID, setOBUserID] = useState("");
	const [obLoanID, setOBLoanID] = useState("");

	const getFieldValues = async () => {
		console.log(
			"LockExtensionRequestCard:getFieldValues:encompassId, loanNumber",
			loanData?.encompassId,
			loanData?.loanNumber
		);

		try {
			const getValues = await field({
				loan_guid: loanData?.encompassId,
				fields:
					"1401,19,VASUMM.X23,1811,1041,356,136,1109,353,976,1540,742,CX.DEBTSERVICECOVERAGERATIO,CX.AUTODEBIT,1550,LCP.X1,2089,762,761,CX.OBTIME,2161,2202,2203,2160,CX.OB.ENTITY.ID,CX.OBLOANID",
			}).unwrap();
			console.log(
				"LockExtensionRequestCard:getFieldValues:all fields",
				getValues?.response
			);

			if(getValues?.response?.length > 0){
				setFieldValues(getValues.response);
			
				const entityField = filterValue(getValues.response, "CX.OB.ENTITY.ID");
				if(entityField !== ""){
					const parts = entityField.split(")")[1].trim();
					const [entity, userID] = parts.split("*");
					setOBEntityID(entity);
					setOBUserID(userID);
			
					const loanID = filterValue(getValues.response, "CX.OBLOANID");
					setOBLoanID(loanID);
			
					console.log("Entity:", entity);
					console.log("UserID:", userID);
					console.log("LoanID:", loanID);
				}
			}
		} catch (err) {
			console.log("LockExtensionRequestCard:getFieldValues:error", err);
		}
	};

	useEffect(() => {
		getFieldValues();
	}, []);

	return (
		<Stack direction="column" className={styles.stackContainer}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				className={styles.topContainer}
			>
			<Heading3
					text="Lock Extension Request"
					extraClass={styles.tabTitle}
					fontType="semibold"
				/>
			</Stack>	
			<LoanParametersSummaryCard loanData={loanData} fieldData={fieldValues} />
			<LockParametersCard loanData={loanData} fieldData={fieldValues} lockRequestedOn={lockRequestedOn} lockStatus={lockStatus} />
			<LockExtensionRequestFormCard loanData={loanData} obLoanID={obLoanID} obEntityID={obEntityID} obUserID={obUserID} goToDefaultView={goToDefaultView} />
			
		</Stack>
	);
};

export default LockExtensionRequestCard;
